import { createFileRoute } from '@tanstack/react-router';
import { DebtorSummaryStats } from '~/components/debtor-summary-stats';
import { DebtorTable } from '~/components/debtor-table';

export const Route = createFileRoute('/_authenticated/debiteuren/')({
    component: DebiteurenPage,
});

function DebiteurenPage() {
    return (
        <div className="flex flex-col gap-4 p-6">
            <h1 className="text-[20px] font-bold text-[#202020]">Debiteuren</h1>
            <DebtorSummaryStats />
            <DebtorTable />
        </div>
    );
}
